import { useContext } from 'react';
import { ServiceItemsContext } from '@context';

export const useServiceItemsContext = () => {
  const context = useContext(ServiceItemsContext);
  return context;
};
